import styled from 'styled-components'

export const ConversationStreamListStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.space.large};
  overflow-y: auto;
`

export const ConversationProgressStubStyled = styled.div`
  align-self: flex-start;
  color: ${(props) => props.theme.colors.text.tertiary};
  font-size: ${(props) => props.theme.typography.pxToRem(14)};
`
